export default __webpack_public_path__ + "static/media/oval_outlined.f20780ea.png";